import store from '@/store';

export const assembleUrl = ({ src, lang, room, deviceId }) => {
  let source = src;
  if (!src.includes('http')) {
    source = location.origin + src;
  }
  try {
    const url = new URL(encodeURI(source));
    url.searchParams.append('lang', lang);
    url.searchParams.append('room', room);
    url.searchParams.append('deviceId', deviceId);
    return url.toString();
  } catch (err) {
    store.dispatch('notification/error', {
      title: 'URL invalid',
      message: err,
    });
  }
  return src;
};

export const queryAssembler = {
  methods: {
    assembleUrl(src) {
      return assembleUrl({
        src,
        lang: this.getLang,
        room: this.getRoom,
        deviceId: this.getDeviceId,
      });
      // let source = src;
      // if (!src.includes('http')) {
      //   source = location.origin + src;
      // }
      // const url = new URL(encodeURI(source));
      // url.searchParams.append('lang', this.getLang);
      // url.searchParams.append('room', this.getRoom);
      // url.searchParams.append('deviceId', this.getDeviceId);
      // return url.toString();
    },
  },
  computed: {
    getLang() {
      return this.$store.state.lang.active;
    },
    getRoom() {
      return this.$store.state.device.room;
    },
    getDeviceId() {
      return this.$store.state.device.deviceId;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/queryAssembler.js